import { useQuery } from '@tanstack/react-query';
import { apiJson } from '@lib/apiClient';
import type { SidecarRecord } from '@/types/intake';

export interface BatchResponse {
  /** Selected on the Bench, not yet moved to Testing. */
  staged: SidecarRecord[];
  /** Moved to the Testing grid, results being set; processed -> Review. */
  testing: SidecarRecord[];
}

/** The caller's own pre-review batch (staged + testing), scoped server-side to this bench user. */
export function useBatch(campaign: string) {
  return useQuery({
    queryKey: ['intake-batch', campaign],
    queryFn: () => apiJson<BatchResponse>(`/api/intake/batch?campaign=${encodeURIComponent(campaign)}`),
    refetchInterval: 30_000,
    refetchOnMount: 'always', // entering Bench/Testing pulls the current batch immediately
  });
}
